const ShoulderedBy = {
    LOCQ: "locq",
    OilCo: "oilco",
    StationTypeDependent: "station-type-dependent"
  };
  
  export default ShoulderedBy;
  